import { StatusBar, HomeBar, Wordmark, Chip } from "./primitives";
import { PLAN } from "./data";

export default function S2({ animate = false }) {
  const an = (i, extra = "") => (animate ? { className: `an ${extra}`, style: { "--i": i } } : {});
  return (
    <div className={`still ${animate ? "animate" : ""}`} data-testid="still-s2" style={{ width: 1080, height: 1920 }}>
      <StatusBar time="6:04" />
      <div style={{ padding: "48px 72px 0" }}>
        <Wordmark size={74} sub="assistant" />
      </div>

      <div style={{ padding: "110px 72px 0", display: "flex", flexDirection: "column", gap: 44 }}>
        <div {...an(0)} style={{ ...an(0).style, alignSelf: "flex-end", maxWidth: 800, background: "var(--blush)", color: "var(--charcoal)", borderRadius: "40px 40px 10px 40px", padding: "36px 44px", fontSize: 38, lineHeight: 1.4 }}>
          {PLAN.request}
        </div>

        <div {...an(2)} style={{ ...an(2).style, alignSelf: "flex-start", maxWidth: 880, background: "#fff", border: "1px solid var(--ink-06)", borderRadius: "40px 40px 40px 10px", padding: "40px 44px", boxShadow: "0 24px 60px -40px rgba(31,31,31,.35)" }}>
          <div className="serif" style={{ fontSize: 46, fontWeight: 500, lineHeight: 1.15 }}>Got it. Here’s what I understood:</div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 16, marginTop: 30 }}>
            {[["mint", "Hydrating Facial"], ["lilac", "Brow Shaping"], ["blush", "Tonight · after 6:00 PM"], ["lilac", "Near SoHo"], ["mint", "Same visit"]].map(([tone, label], i) => (
              <span key={label} {...an(4 + i, "an-pop")}><Chip tone={tone}>{label}</Chip></span>
            ))}
          </div>
          <div {...an(10)} style={{ ...an(10).style, marginTop: 36, display: "flex", alignItems: "center", gap: 18, color: "var(--ink-60)", fontSize: 32 }}>
            <span style={{ width: 16, height: 16, borderRadius: "50%", background: "var(--burgundy)" }} />
            Finding a spa that can do both tonight…
          </div>
          <div {...an(11)} style={{ ...an(11).style, marginTop: 26, display: "flex", flexDirection: "column", gap: 14 }}>
            <span style={{ height: 22, width: "78%", borderRadius: 11, background: "var(--ink-06)" }} />
            <span style={{ height: 22, width: "54%", borderRadius: 11, background: "var(--ink-06)" }} />
          </div>
        </div>
      </div>

      <div style={{ position: "absolute", left: 72, right: 72, bottom: 96, height: 108, borderRadius: 999, background: "#fff", border: "1px solid var(--ink-12)", display: "flex", alignItems: "center", padding: "0 44px", color: "var(--ink-40)", fontSize: 34 }}>
        Ask marova anything
        <span style={{ marginLeft: "auto", width: 72, height: 72, borderRadius: "50%", background: "var(--charcoal)" }} />
      </div>
      <HomeBar />
    </div>
  );
}
